import { render, staticRenderFns } from "./AlertaVigenciaCupPersonalComponent.vue?vue&type=template&id=3a1b6684&"
import script from "./AlertaVigenciaCupPersonalComponent.vue?vue&type=script&lang=js&"
export * from "./AlertaVigenciaCupPersonalComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
installComponents(component, {VAlert})
